import {
  ApiReducer,
  makeApiAction,
  makeApiReducer,
  RsaaTypes,
} from '../../../../core/redux/api/reduxStandardApiAction';
import { apiDisableMedia } from '../../../../core/redux/api/endpoints';
import { IAppState } from '../../../../core/redux/IAppState';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../../../core/redux/api/module';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import { hasTrippedBreaker, updateBreaker } from '../../../../core/redux/api/circuitBreaker/module';


export interface DisableMediaPayload {
  userId: string,
  resortAbbreviation: string,
  chipId: string,
  mediaId: string,
  masterGuestId: string,
  operatorId: string,
}


export const KEY_ACTION = ACTION_TYPE.DISABLE_GUEST_MEDIA_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.DISABLE_GUEST_MEDIA_REQUEST,
  ACTION_TYPE.DISABLE_GUEST_MEDIA_RESPONSE,
  ACTION_TYPE.DISABLE_GUEST_MEDIA_ERROR,
];


/**
 * Constructs an action that can be dispatched to disable a guest media if lost/stolen/etc
 */

export const disableMediaAction = (payload: DisableMediaPayload, guestId: string) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: apiDisableMedia,
    body:     JSON.stringify(payload),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, payload.masterGuestId, KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<DisableMediaPayload> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId!, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId!, KEY_ACTION, error);
  }

  return removeLoadingAndError(withBreaker, guestId!, KEY_ACTION);
};


export const disableMediaReducer = makeApiReducer<DisableMediaPayload>(ACTIONS, KEY_ACTION, reducer);
